import React from 'react';
import {useMutation} from '@apollo/client';
import {Button} from 'antd';

import {createPayment, createPaymentVariables} from '../../shared/graphql/__generated__/createPayment';
import {MUTATION_CREATE_PAYMENT} from '../../shared/graphql/payment';

interface PaymentProps {
    orderId: string;
}

export const Payment: React.FC<PaymentProps> = ({orderId}) => {
    const [createPaymentMutation, {loading}] = useMutation<createPayment, createPaymentVariables>(MUTATION_CREATE_PAYMENT);

    const handlePayment = async () => {
        try {
            const result = await createPaymentMutation({
                variables: {
                    data: {
                        order: orderId
                    }
                }
            });

            if (result.data?.createPayment?.paymentUrl) {
                // Перенаправляем на страницу оплаты
                window.location.href = result.data.createPayment.paymentUrl;
            }
        } catch (error) {
            console.error('Ошибка при создании платежа:', error);
        }
    };

    return (
        <Button 
            type={'primary'} 
            size={'large'} 
            onClick={handlePayment} 
            loading={loading}
        >
            Перейти к оплате
        </Button>
    );
};

